import React from 'react';

// One cell of a .pm-kpis summary strip: label, big value, optional caption.
// With `onClick` the tile acts as a button (e.g. to filter the list below).
const KpiTile = ({ label, value, sub, valueColor, title, onClick }) => (
  <div
    className={`pm-kpi${onClick ? ' pm-kpi-clickable' : ''}`}
    title={title}
    {...(onClick ? {
      role: 'button',
      tabIndex: 0,
      onClick,
      onKeyDown: (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      },
    } : {})}
  >
    <div className="pm-kpi-label">{label}</div>
    <div className="pm-kpi-value" style={valueColor ? { color: valueColor } : undefined}>
      {value}
    </div>
    {sub && <div className="pm-kpi-sub">{sub}</div>}
  </div>
);

export default KpiTile;
